









































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseDataTable from '@/components/BaseDataTable.vue';
import moment from 'moment';
import Auth from '@/connector/Auth.vue';
import TransactionService from '@/services/TransactionService';
import BaseDateRangeSearch from '@/components/BaseDateRangeSearch.vue';
import Notification from '@/connector/Notification.vue';
import BaseConfirmDialog from '@/components/BaseConfirmDialog.vue';

const transactionService = new TransactionService();

@Component({
  components: {
    BaseDataTable,
    Auth,
    BaseDateRangeSearch,
    Notification,
    BaseConfirmDialog,
  },
})
export default class DepositRequest extends Vue {
  public loading: boolean = false;

  // eslint-disable-next-line max-len
  public range: string = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')].toString();

  public totalTransaction: number = 0;

  public totalAmount: number = 0;

  public pendingAmount: number = 0;

  public pendingTransction: number = 0;

  public rejectedAmount: number = 0;

  public rejectedTransction: number = 0;

  public approvedAmount: number = 0;

  public approvedTransction: number = 0;

  public textSearch: string = '';

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  // eslint-disable-next-line class-methods-use-this
  get withdrawListUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions/admin/withdraw`;
  }

  // eslint-disable-next-line class-methods-use-this
  async search(data: any) {
    this.range = data;
  }

  @Watch('range')
  async onRangeChange() {
    await this.getWithdrawSummary();
  }

  // eslint-disable-next-line @typescript-eslint/camelcase
  async updateWithdrawReuqest(request_id: string, status: string, transferType: string,
    bankTransfer: boolean) {
    try {
      // eslint-disable-next-line max-len
      const confirm = await (this.$refs.WITHDRAW_CONFIRM_DIALOG as Vue & { open: (data: any) => boolean }).open({ title: 'ยืนยันการทำรายการถอนเงิน' });
      if (!confirm) return;
      this.loading = true;
      await transactionService.updateWithdrawRequest({
        // eslint-disable-next-line @typescript-eslint/camelcase
        request_id, status, transferType, bankTransfer,
      });
      (this.$refs.WITHDRAW_TABLE as Vue & { refreshData: () => void }).refreshData();
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการเสร็จสิ้น', error: false });
    } catch (e) {
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }

  async cancelWithdraw(uuid: string) {
    try {
      this.loading = true;
      await transactionService.cancelZappayWithdraw(uuid);
      (this.$refs.WITHDRAW_TABLE as Vue & { refreshData: () => void }).refreshData();
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการเสร็จสิ้น', error: false });
    } catch (e) {
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  countRequest(type: string, data: any) {
    console.log('data', data);
    const transactions = data
      .filter((transaction: { status: string }) => transaction.status === type);
    return {
      total: transactions.length,
      amount: transactions.reduce((acc: number, current: any) => acc + current.amount, 0),
    };
  }

  async getWithdrawSummary() {
    const { data } = await transactionService.getRequestSummary('withdraw', this.range, this.textSearch);
    const pendingData = this.countRequest('PENDING', data);
    const rejectedData = this.countRequest('REJECTED', data);
    const approvedData = this.countRequest('APPROVED', data);
    this.totalTransaction = data.length;
    this.totalAmount = data
      .reduce((acc: number, current: any) => acc + current.amount, 0)
      .toFixed(2);
    this.pendingAmount = pendingData.amount.toFixed(2);
    this.pendingTransction = pendingData.total;
    this.rejectedAmount = rejectedData.amount.toFixed(2);
    this.rejectedTransction = rejectedData.total;
    this.approvedAmount = approvedData.amount.toFixed(2);
    this.approvedTransction = approvedData.total;
  }

  public setSearchText(value: string) {
    this.textSearch = value;
  }

  get dateText() {
    const date = this.range.split(',');
    return `${date[0]} - ${date[1]}`;
  }

  // eslint-disable-next-line class-methods-use-this
  public reloadPage() {
    window.location.reload();
  }

  async created() {
    await this.getWithdrawSummary();
    this.$store.dispatch('Notification/removeRequestState', 'withdraw');
  }
}
